module.exports = __webpack_public_path__ + "media/images/iPhonex-d3e417429bb4ba3ab35200d1beb526a5.png";